// Spec 078 FR-040 — o que a TV mostra quando o link foi revogado (ou nunca existiu) e o que a
// tela mostra quando a linha não existe. NEUTRO de propósito: sem nome de linha, sem organização,
// sem distinguir "revogado" de "inexistente" (o backend também não distingue).
import * as React from "react";
import { MonitorOff } from "lucide-react";

export interface AmbientInactiveProps {
  reason: "link" | "line";
}

export function AmbientInactive({ reason }: AmbientInactiveProps): React.ReactElement {
  const title = reason === "link" ? "Link desativado" : "Linha não encontrada";
  const description =
    reason === "link"
      ? "Este link de exibição não está mais ativo. Peça a um gestor para gerar um novo link para esta TV."
      : "A linha pedida não existe ou foi removida. Confira o endereço e tente de novo.";
  return (
    <main
      className="flex h-screen flex-col items-center justify-center gap-6 bg-bg-inverse px-8 text-center text-text-inverse"
      data-testid="ambient-inactive"
    >
      <MonitorOff className="h-24 w-24 text-text-inverse-secondary" aria-hidden />
      <h1 className="text-5xl font-bold">{title}</h1>
      <p className="max-w-2xl text-3xl text-text-inverse-secondary">{description}</p>
    </main>
  );
}
